






helpers = require('../../helpers.coffee')

view_model =
  props: ['additional']

  computed:
    additional_time_in_minutes:
      get: ->
        return 0 unless @additional
        parseInt(@additional.seconds / 60)
      set: (value) ->
        return unless @additional
        @additional.seconds = parseInt(value || 0) * 60

    consumed_in_minutes: ->
      return '' unless @additional
      this.$t('companies.feedback.consummedMinutes')

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/companies/additional_minute.vue